import InvestigationListStream from './InvestigationListStream.js'
import InvestigationRecorder from './InvestigationRecorder.js'
import DomainObjectStreams from './DomainObjectStreams.js'
import PlatformApi from './PlatformApi.js'
import {EventEmitter} from 'events'
import {Writable} from 'stream'
import PropertyStream from 'pw-property-stream'

export default class ImmersiveData {
  constructor (options = {}) {
    this.namePrefix = options.namePrefix != null ? options.namePrefix : ''
    this.events = new EventEmitter()

    this.authStreamOutput = PropertyStream({})
    this.platformApi = new PlatformApi(this.events)

    this.investigationRecorder = new InvestigationRecorder(this.events)
    this.investigationListStream = new InvestigationListStream(this.events).output

    this.domainObjects = new DomainObjectStreams(this.events)
    this.authorized = false

    if (options.streamingClient) { this.setStreamingClient(options.client) }
  }

  // this function can only be called once
  init (streamingClient, routeStream) {
    if (this.streamingClient) { return }
    this.streamingClient = streamingClient
    this.routeStream = routeStream || PropertyStream()
    this.events.emit('init', this.namePrefix, this.streamingClient, this.routeStream)
    this._authenticate()
  }

  _authenticate () {
    if (!this.streamingClient) { return }
    this.authStream = this.streamingClient.create({
      name: `${this.namePrefix}authentication`,
      path: 'authentication'
    })
    const authHandler = Writable({
      objectMode: true,
      highWaterMark: 0,
      write: ({action, authorized, authCode}, enc, next) => {
        if (action === 'login' && authorized && !this.authorized) {
          this.authorized = true
          this.events.emit('authenticated')
        }
        if (action === 'logout' && !authorized && this.authorized) {
          this.authorized = false
          this.events.emit('unauthenticated')
        }
        next()
      }
    })
    this.authStream.pipe(this.authStreamOutput)
    this.authStream.pipe(authHandler)
  }

  destroy () {
    this.streamingClient.destroy()
    this.streamingClient = null
    this.events.emit('destroy')
    this.events.removeAllListeners()
  }
}
